import { render, staticRenderFns } from "./UserForgetPassword.vue?vue&type=template&id=fc456de4&scoped=true"
import script from "./UserForgetPassword.vue?vue&type=script&lang=js"
export * from "./UserForgetPassword.vue?vue&type=script&lang=js"
import style0 from "./UserForgetPassword.vue?vue&type=style&index=0&id=fc456de4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc456de4",
  null
  
)

export default component.exports